import React, { useState, useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { versionService } from '../services/versionService';

// How often to check for updates (in milliseconds)
const CHECK_INTERVAL = 5 * 60 * 1000; // 5 minutes

const UpdatePrompt: React.FC = () => {
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    // Check for updates when component mounts
    checkForUpdates();

    // Set up interval to periodically check for updates
    const intervalId = setInterval(checkForUpdates, CHECK_INTERVAL);

    // Clean up interval on unmount
    return () => clearInterval(intervalId);
  }, []);

  const checkForUpdates = async () => {
    try {
      const hasNewVersion = await versionService.checkForNewVersion();
      
      if (hasNewVersion) {
        setShowPrompt(true);
      }
    } catch (error) {
      console.error('Error checking for updates:', error);
    }
  };

  const handleReload = () => {
    window.location.reload();
  };

  const handleDismiss = () => {
    setShowPrompt(false);
  };

  // Update prompt only makes sense in a web browser — native apps update via the app store
  if (!showPrompt || Capacitor.isNativePlatform()) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-brand-primary text-white shadow-lg max-w-[600px] mx-auto">
      <div className="flex justify-between items-center">
        <div>
          <p className="font-medium">A new version is available</p>
          <p className="text-sm opacity-90">Please reload to update</p>
        </div>
        <div className="flex space-x-2">
          <button
            onClick={handleDismiss}
            className="px-3 py-1 text-sm bg-transparent border border-white/30 rounded hover:bg-white/10 transition-colors"
          >
            Later
          </button>
          <button
            onClick={handleReload}
            className="px-3 py-1 text-sm bg-white text-brand-primary rounded font-medium hover:bg-white/90 transition-colors"
          >
            Reload
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdatePrompt;
